import InputForm from "components/agro/inputs/InputForm";

const InputCreateForm = ({ onSuccess }) => {
  const input = {
    id: "",
    name: "",
    activeIngredient: "",
    unit: "",
    classification: "",
    physicalType: "",
    icaRegistration: "",
    toxicologicalCategory: "",
  };

  async function onSubmit(valuesParam) {
    if (onSuccess) onSuccess();
  }

  return (
    <div>
      <InputForm onSubmit={onSubmit} initialValues={input} />
    </div>
  );
};

export default InputCreateForm;
